import SolutionsHero from "./SolutionsHero";
import SolutionBlock from "./SolutionBlock";
import ResultsSection from "./ResultsSection";
import orderingImage from '../../../static/images/Screenshot 2025-08-12 204601.jpg';
import menuImage from '../../../static/images/pexels-cottonbro-5077068.jpg';


function Solutions() {
    return (
        <>
            <SolutionsHero />

            <SolutionBlock
                id="menu"
                overline="Menu Management"
                title="Keep your menus fresh everywhere"
                blurb="Update items and prices once. Your website, specials, and featured dishes stay in sync across pages and devices."
                image={menuImage}
                bullets={[
                    "Simple editor for food & drink items",
                    "Sections, tags, allergens, and pricing",
                    "Daily specials & seasonal menus",
                    "Auto‑formatted layouts (mobile‑first)"
                ]}
            />

            <SolutionBlock
                id="ordering"
                overline="Online Ordering"
                title="Take pickup and delivery orders on your site"
                blurb="Branded checkout, easy item modifiers, and POS‑friendly flows that reduce errors at the counter."
                image={orderingImage}
                bullets={[
                    "Pickup & delivery flows",
                    "Modifiers, combos, & notes",
                    "Order throttling & hours",
                    "Receipts & notifications"
                ]}
                reverse
            />

            <ResultsSection />

        </>
    );
}

export default Solutions;